import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RoutingStateService, ToastService } from '@brightside/brightside-ui-services';
import { ApiResponse, CreditSetupResponse, CreditSetupStatus, FirebaseService } from '@brightside-web/desktop/data-access/shared';
import { CreditSetupService } from '@brightside-web/desktop/data-access/credit';
import { BsCacheService, BsHubService } from '@brightside-web/desktop/data-access/core-services';
import { Subscription } from 'rxjs';


@Component({
    selector: 'brightside-web-creation-waiting',
    templateUrl: './creation-waiting.component.html',
    standalone: false
})
export class CreationWaitingComponent implements OnInit, OnDestroy {
  private sub = new Subscription();

  processing = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private routingState: RoutingStateService,
    private creditSetupService: CreditSetupService,
    private toastService: ToastService,
    protected analytics: FirebaseService,
    private bsHubService: BsHubService,
    private bsCacheService: BsCacheService
  ) {

  }

  ngOnInit() {
    this.setUpHub();
    this.subscribeAndStartCredit();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private setUpHub() {
    this.bsHubService.listen('ErrorChannel', () => {});
  }

  private subscribeAndStartCredit() {
    const handleSuccess = (resp: CreditSetupResponse) => {
      if (resp.status === CreditSetupStatus.VERIFY_SMFA) {
        this.bsCacheService.setItem('smfaTimeTimeoutInMinutes', resp.smfaTimeTimeoutInMinutes || 4);
        this.handleRouteForward(true, { state: { smfaTimeTimeoutInMinutes: resp.smfaTimeTimeoutInMinutes || 4 } });
        return;
      }
      else if (resp.status === CreditSetupStatus.VERIFY_DIT) {
        this.router.routeReuseStrategy.shouldReuseRoute =  () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/verification/identity/creditScore'], {state: {error: 'credit_dit_error'}});
        return;
      }
      else if (resp.status === CreditSetupStatus.VERIFICATION_FAILED) {
        this.handleRouteWithCode(resp.status);
        return;
      }
      this.handleRoute(true, ['credit-setup', 'creation']);
    };

    const handleFailure = (errorResp: ApiResponse) => {
      this.handleRouteWithCode(CreditSetupStatus.VERIFICATION_FAILED);
      this.analytics.logEvent('error_shown', {'error id': 'credit_failed_smfa'});
    };

    this.sub.add(this.creditSetupService.startSetup().subscribe(handleSuccess, handleFailure));
  }

  private handleRoute(popHistory: boolean, routeHere: string[], options: any = {}) {
    if (popHistory) {
      this.routingState.popAndNavigateTo(routeHere, options);
    } else {
      this.router.navigate(routeHere, options);
    }
  }

  private handleRouteForward(popHistory?: boolean, options: any = {}) {
    this.handleRoute(popHistory || false, ['credit-setup', 'verify', 'smfa'], options);
  }

  private handleRouteWithCode(code: CreditSetupStatus) {
    this.handleRoute(true, ['credit-setup', 'creation'], { queryParams: { status: code } });
  }
}
